
import React from "react";
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { UseFormReturn } from "react-hook-form";
import { ContactFormValues } from "./ContactFormSchema";

interface ContactRoleFieldProps {
  form: UseFormReturn<ContactFormValues>;
}

export function ContactRoleField({ form }: ContactRoleFieldProps) {
  return (
    <FormField
      control={form.control}
      name="role"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Role</FormLabel>
          <Select onValueChange={field.onChange} value={field.value}>
            <FormControl>
              <SelectTrigger>
                <SelectValue placeholder="Select role" />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              <SelectItem value="Account Manager">Account Manager</SelectItem>
              <SelectItem value="Sales Representative">Sales Representative</SelectItem>
              <SelectItem value="Legal Contact">Legal Contact</SelectItem>
              <SelectItem value="Technical Contact">Technical Contact</SelectItem>
              <SelectItem value="Billing Contact">Billing Contact</SelectItem>
              <SelectItem value="Executive">Executive</SelectItem>
              <SelectItem value="Other">Other</SelectItem>
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
